var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 90,
    viewBox: "0 0 72 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m70.24376,23.74047l-.41156.71661-21.81265,37.98018-9.93622,17.30095c-5.63563,9.81276-18.14838,13.17911-27.89296,7.50405C.4458,81.56718-2.89701,68.96683,2.73863,59.15407L34.89906,3.15634c.67659-1.17808,2.1734-1.58085,3.34329-.89952s1.56971,2.18865.89311,3.36673L6.97503,61.62128c-4.28463,7.46039-1.74304,17.04011,5.66552,21.35472s16.92174,1.75539,21.20637-5.705l9.93622-17.30095,21.81265-37.98018c3.11753-5.42824,1.26831-12.3985-4.12231-15.53791s-12.31245-1.27724-15.42998,4.151l-4.17439,7.26844L15.78992,63.28049c-1.67271,2.91252-.68043,6.65238,2.21194,8.33685l.62347.3631c2.89238,1.68447,6.6063.68541,8.279-2.22711l30.66515-53.39413c.67659-1.17808,2.1734-1.58085,3.34329-.89952s1.56971,2.18865.89311,3.36673l-30.66515,53.39413c-3.02371,5.26488-9.73719,7.07108-14.96559,4.02615l-.62347-.3631c-5.2284-3.04493-7.02188-9.80543-3.99817-15.07031L37.63271,15.40419l4.17439-7.26844.41156-.71661c.09283-.16163.20229-.30714.32302-.4388C47.29313.1031,56.59414-2.08288,63.92367,2.18571c7.32953,4.26859,10.08657,13.47697,6.53669,21.05398-.05312.17103-.12377.33915-.21659.50078Z",
    fill: "#262626",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.88386f163711aee41bdcc3558aed3148.svg";
export { ForwardRef as ReactComponent };